export enum WeekDays {
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday'
}

interface IOnCallSchedule {
  startTime: string;
  endTime: string;
}

export type OnCallSupportRoster = Record<WeekDays, Array<IOnCallSchedule>>;
